<template>
  <div>
    <h1>Crea Nuovo Questionario</h1>
    <div>
      <div class="col-10 mx-auto">
        <b-form @submit="onSubmit">
          <b-form-group
            label="Nome questionario"
            label-for="nome"
            description="Nome del disturbo di riferimento, appare nell'elenco di opzioni di questionari"
            class="text-left"
          >
            <b-form-input
              v-model="form.nome"
              type="text"
              id="nome"
              placeholder="Nome questionario"
              class="my-2"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Info questionario"
            label-for="info"
            description="Alert/disclaimer di avvio al questionario"
            class="text-left"
          >
            <b-form-textarea
              v-model="form.info"
              type="text"
              id="info"
              placeholder="Info questionario"
              class="my-2"
              required
              rows="4"
            ></b-form-textarea>
          </b-form-group>

          <b-overlay :show="loading" rounded="sm">
            <b-card
              :title="'Domanda ' + domanda.order"
              v-for="(domanda, ind) in form.domande"
              :key="ind"
              class="p-1 border-secondary rounded bg-medium-grey text-left my-1"
            >
              <b-form-group>
                <b-form-input
                  v-model="domanda.q"
                  type="text"
                  placeholder="Domanda"
                  class="my-2"
                  required
                ></b-form-input>
                <b-form-radio-group
                  v-model="domanda.o"
                  :name="'domanda' + domanda.order"
                  :id="'domanda' + domanda.order"
                  class="my-2"
                  required
                >
                  <b-form-radio :value="null">Solo testo</b-form-radio>
                  <b-form-radio :value="domanda.o ? domanda.o : []"
                    >Opzioni precompilate</b-form-radio
                  >
                  <b-form-radio :value="['file']"
                    >Caricamento Immagine</b-form-radio
                  >
                </b-form-radio-group>
                <b-form-tags
                  v-if="domanda.o && domanda.o[0] != 'file'"
                  v-model="domanda.o"
                  class="mb-2"
                  placeholder="aggiungi opzioni risposta"
                  remove-on-delete
                ></b-form-tags>
              </b-form-group>
            </b-card>
          </b-overlay>
          <div class="d-flex mx-auto justify-content-center">
            <b-button
              type="button"
              variant="primary"
              @click="addNew"
              class="mx-auto"
              >Aggiungi domanda +</b-button
            >
            <b-button
              type="button"
              variant="primary"
              @click="addCompilate"
              class="mx-auto"
              >Aggiungi domande finali</b-button
            >

            <b-button type="submit" variant="primary" class="mx-auto"
              >Salva</b-button
            >
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NuovoQuestionario",
  data() {
    return {
      loading: false,
      opzione: null,
      precompilate: [
        {
          q: "Stai prendendo dei farmaci per questo problema?",
          o: ["si", "no"],
          a: "",
          //   order: len && len + 1
        },
        {
          q: "Se sì: quali?",
          o: null,
          a: "",
          //   order: len && len + 2
        },
        {
          q: "Stai prendendo altri dei farmaci non correlati al problema?",
          o: ["si", "no"],
          a: "",
          //   order: len && len + 3
        },
        {
          q: "Se sì: quali?",
          o: null,
          a: "",
          //   order: len && len + 4
        },
        {
          q: "Sei allergico a qualche farmaco?",
          o: ["si", "no"],
          a: "",
          //   order: len && len + 5
        },
        {
          q: "Se sì: Quali?",
          o: null,
          a: "",
          //   order: len && len + 6
        },
        {
          q: "Vuoi aggiungere qualcosa?",
          o: null,
          a: "",
          //   order: len && len + 7
        },
      ],
      form: {
        nome: null,
        info:
          "Attenzione: continuando ad usare l'app, acconsenti al trattamento dei tuoi dati sanitari per informare il medico per un consulto e per finalità di analisi in forma anonima. Maggiori dettagli saranno reperibili alla Privacy policy.",
        domande: [],
      },
    };
  },
  computed: {
    len: function() {
      if (this.form && this.form.domande) {
        return this.form.domande.length;
      }
      return 0;
    },
  },
  methods: {
    addNew() {
      this.loading = true;
      var newQ = {
        q: null,
        o: null,
        a: "",
        order: this.form.domande.length + 1,
      };
      //   this.form.domande.unshift(newQ);
      this.form.domande.push(newQ);

      this.loading = false;
    },
    addCompilate() {
      this.form.domande.push(...this.precompilate);
    },
    onSubmit(evt) {
      evt.preventDefault();
      // console.log(this.form);
      //   !this.validate() && this.sendForm();
    },
  },
};
</script>
